import {ClientService, PutUserOptions, GetUserOptions, ClientProfileResponse} from '@simpleinvest/ms-client-sdk';
import {apiKey, getLogger} from '@client/services/sdk';
// eslint-disable-next-line import/no-cycle
import {
  requestInterceptorFulfilledHandler,
  requestInterceptorRejectedHandler,
  responseInterceptorFulfilledHandler,
  responseInterceptorRejectedHandler,
} from '@client/interceptors';
import {SourcePlatform} from '@simpleinvest/ms-core-sdk';

export default {
  getClientServiceInstance(): ClientService {
    return new ClientService({
      apiKey,
      sourceInfo: {platform: SourcePlatform.ClientPlatform},
      interceptors: {
        requestInterceptor: requestInterceptorFulfilledHandler,
        requestRejectedInterceptor: requestInterceptorRejectedHandler,
        responseInterceptor: responseInterceptorFulfilledHandler,
        responseRejectedInterceptor: responseInterceptorRejectedHandler,
      },
      logger: getLogger(),
    });
  },
  async updateClientPersonalInfo(payload: PutUserOptions): Promise<unknown> {
    const service: ClientService = await this.getClientServiceInstance();

    return service.updateClient(payload);
  },
  async getClientInfo(payload: GetUserOptions): Promise<unknown> {
    const service: ClientService = await this.getClientServiceInstance();

    return service.getClUserDetails(payload);
  },
  async getUser(): Promise<ClientProfileResponse> {
    const service: ClientService = await this.getClientServiceInstance();

    return service.getClientProfile({});
  },
};
